(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["army-filter-bar"] && !Shopify.designMode) return;
  try {
    /* Intercept army-pill clicks and route through Dawn's
     FacetFiltersForm.renderPage so filtering happens via AJAX (matching
     the desktop sidebar / mobile drawer behavior) instead of a full
     navigation. The snippet sits inside ProductGridContainer, which
     renderPage replaces, so the active pill highlights automatically
     after each swap. */
  document.addEventListener('click', function (event) {
    var pill = event.target.closest('.army-filter-bar__pill, .army-filter-bar__clear');
    if (!pill) return;
    if (typeof FacetFiltersForm === 'undefined' || typeof FacetFiltersForm.renderPage !== 'function') {
      return; // fall back to normal link navigation
    }
    event.preventDefault();
    var href = pill.getAttribute('href') || '';
    var qIndex = href.indexOf('?');
    var searchParams = qIndex >= 0 ? href.slice(qIndex + 1) : '';
    FacetFiltersForm.renderPage(searchParams, event);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["back-in-stock-form"] && !Shopify.designMode) return;
  try {
    class BackInStockForm extends HTMLElement {
    constructor() {
      super();
      this.companyId = (this.dataset.companyId || '').trim();
      this.boundVariantHandler = this.onVariantChange.bind(this);
    }

    connectedCallback() {
      // On mobile, portal ourselves to <body> so position:fixed is
      // anchored to the viewport, not to any product-page ancestor that
      // creates a containing block (transform, contain, backdrop-filter,
      // etc.). On desktop we stay inline next to the buy buttons.
      // Re-parenting fires disconnect → connect; the _portalChecked
      // flag stops us from looping on the second entry.
      if (!this._portalChecked) {
        this._portalChecked = true;
        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        if (isMobile && this.parentElement && this.parentElement !== document.body) {
          document.body.appendChild(this);
          return;
        }
      }

      // Idempotent wiring. If we ever get re-connected (e.g. theme
      // editor section re-render), don't double-bind listeners.
      if (this._wired) return;
      this._wired = true;

      const form = this.querySelector('form');
      if (form) {
        form.addEventListener('submit', (event) => this.handleSubmit(event));
      }

      // Mobile drawer minimize/expand. Both controls live in the DOM at
      // every breakpoint — they're hidden on desktop via CSS, so wiring
      // them unconditionally is safe and keeps this code breakpoint-free.
      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-bis-close]')) {
          this.minimize();
        } else if (event.target.closest('[data-bis-toggle]')) {
          this.expand();
        }
      });

      // Subscribe to Dawn's variant change pub/sub. The form lives outside
      // the product DOM (we portaled it to body) so we listen globally
      // and read the variant from the event payload.
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, this.boundVariantHandler);
      }
    }

    minimize() {
      this.classList.add('back-in-stock-form--minimized');
    }

    expand() {
      this.classList.remove('back-in-stock-form--minimized');
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
    }

    onVariantChange(event) {
      const variant = event && event.data && event.data.variant;
      const errorEl = this.querySelector('[data-bis-error]');
      const successEl = this.querySelector('[data-bis-success]');
      if (errorEl) errorEl.hidden = true;
      if (successEl) successEl.hidden = true;

      // No matching variant for the chosen options, or variant is in
      // stock — either way, no notify-me form needed.
      if (!variant || variant.available) {
        this.hidden = true;
        // Reset minimized state so a future sold-out variant gets the
        // full drawer again, not the collapsed tab.
        this.expand();
        return;
      }

      this.dataset.variantId = variant.id;
      this.hidden = false;
    }

    async handleSubmit(event) {
      event.preventDefault();
      const form = event.currentTarget;
      const emailInput = form.querySelector('input[type="email"]');
      const submitButton = form.querySelector('button[type="submit"]');
      const errorEl = this.querySelector('[data-bis-error]');
      const successEl = this.querySelector('[data-bis-success]');
      const email = emailInput && emailInput.value.trim();
      const variantId = (this.dataset.variantId || '').trim();

      if (errorEl) errorEl.hidden = true;
      if (successEl) successEl.hidden = true;

      if (!email) {
        this.showError(errorEl, 'Please enter a valid email address.');
        return;
      }
      if (!this.companyId || !variantId) {
        this.showError(errorEl, "Notifications aren't configured yet.");
        return;
      }

      if (submitButton) submitButton.disabled = true;

      try {
        // Per-variant back-in-stock subscription. Klaviyo's catalog feed
        // matches this against the Shopify variant; when the variant
        // restocks, the built-in "Back in Stock" metric fires the
        // notification email automatically — no list needed.
        const response = await this.subscribeBackInStock(email, variantId);
        if (!response.ok) throw new Error(`Klaviyo responded ${response.status}`);

        if (emailInput) emailInput.value = '';
        if (successEl) successEl.hidden = false;
      } catch (_) {
        this.showError(errorEl, 'Something went wrong. Please try again.');
      } finally {
        if (submitButton) submitButton.disabled = false;
      }
    }

    subscribeBackInStock(email, variantId) {
      return fetch(
        `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${encodeURIComponent(this.companyId)}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            revision: '2024-10-15',
          },
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                channels: ['EMAIL'],
                profile: {
                  data: {
                    type: 'profile',
                    attributes: { email },
                  },
                },
              },
              relationships: {
                variant: {
                  data: {
                    type: 'catalog-variant',
                    // Klaviyo Shopify catalog variant ID format.
                    id: `$shopify:::$default:::${variantId}`,
                  },
                },
              },
            },
          }),
        }
      );
    }

    showError(el, text) {
      if (!el) return;
      el.textContent = text;
      el.hidden = false;
    }
  }

  if (!customElements.get('back-in-stock-form')) {
    customElements.define('back-in-stock-form', BackInStockForm);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-drawer-upsell"] && !Shopify.designMode) return;
  try {
    class CartDrawerUpsell extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.cd-upsell__track');
      this.prev = this.querySelector('.cd-upsell__nav--prev');
      this.next = this.querySelector('.cd-upsell__nav--next');
      if (!this.track || !this.prev || !this.next) return;

      this.prev.addEventListener('click', () => this._scroll(-1));
      this.next.addEventListener('click', () => this._scroll(1));
      this.track.addEventListener('scroll', () => this._updateNav(), { passive: true });

      this._updateNav();
      this._resizeObserver = new ResizeObserver(() => this._updateNav());
      this._resizeObserver.observe(this.track);
    }

    disconnectedCallback() {
      if (this._resizeObserver) this._resizeObserver.disconnect();
    }

    _scroll(direction) {
      const firstItem = this.track.querySelector('.cd-upsell__item');
      const gap = parseFloat(getComputedStyle(this.track).columnGap || '8') || 8;
      const step = firstItem ? firstItem.offsetWidth + gap : this.track.clientWidth * 0.8;
      this.track.scrollBy({ left: step * direction, behavior: 'smooth' });
    }

    _updateNav() {
      const max = this.track.scrollWidth - this.track.clientWidth - 1;
      const x = this.track.scrollLeft;
      this.prev.hidden = x <= 0;
      this.next.hidden = x >= max;
    }
  }

  if (!customElements.get('cart-drawer-upsell')) {
    customElements.define('cart-drawer-upsell', CartDrawerUpsell);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    class CartDisclaimerCarousel extends HTMLElement {
    constructor() {
      super();
      this.interval = 4500;
      this.timer = null;
      this.current = 0;
    }

    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.cart-drawer__disclaimer-slide'));
      this.dots = Array.from(this.querySelectorAll('.cart-drawer__disclaimer-dot'));
      this.arrows = Array.from(this.querySelectorAll('.cart-drawer__disclaimer-arrow'));
      this.track = this.querySelector('.cart-drawer__disclaimer-track');
      if (this.slides.length < 2) return;

      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          this.go(i);
          this.restart();
        });
      });

      this.arrows.forEach((arrow) => {
        arrow.addEventListener('click', () => {
          if (arrow.dataset.direction === 'prev') {
            this.prev();
          } else {
            this.next();
          }
          this.restart();
        });
      });

      // Pause rotation while the visitor is hovered/focused on the
      // carousel so they have time to read.
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());

      this._bindSwipe();

      this.start();
    }

    _bindSwipe() {
      // Horizontal-swipe navigation. We track touch deltas and only
      // commit a slide change once the gesture is clearly horizontal
      // and exceeds the threshold, so vertical scrolling through the
      // cart isn't hijacked.
      const target = this.track || this;
      const SWIPE_THRESHOLD = 40;
      let startX = 0;
      let startY = 0;
      let active = false;

      target.addEventListener(
        'touchstart',
        (event) => {
          const t = event.changedTouches && event.changedTouches[0];
          if (!t) return;
          startX = t.clientX;
          startY = t.clientY;
          active = true;
          this.stop();
        },
        { passive: true }
      );

      target.addEventListener(
        'touchend',
        (event) => {
          if (!active) return;
          active = false;
          const t = event.changedTouches && event.changedTouches[0];
          if (!t) {
            this.start();
            return;
          }
          const dx = t.clientX - startX;
          const dy = t.clientY - startY;
          if (Math.abs(dx) > SWIPE_THRESHOLD && Math.abs(dx) > Math.abs(dy)) {
            if (dx < 0) {
              this.next();
            } else {
              this.prev();
            }
            this.restart();
          } else {
            this.start();
          }
        },
        { passive: true }
      );
    }

    prev() {
      this.go((this.current - 1 + this.slides.length) % this.slides.length);
    }

    disconnectedCallback() {
      this.stop();
    }

    start() {
      this.stop();
      this.timer = window.setInterval(() => this.next(), this.interval);
    }

    stop() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    restart() {
      this.start();
    }

    next() {
      this.go((this.current + 1) % this.slides.length);
    }

    go(index) {
      this.slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
      });
      this.dots.forEach((dot, i) => {
        const active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      this.current = index;
    }
  }

  if (!customElements.get('cart-disclaimer-carousel')) {
    customElements.define('cart-disclaimer-carousel', CartDisclaimerCarousel);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["facets"] && !Shopify.designMode) return;
  try {
    /* Warhaus filter UX — owns:
     1. Price slider sync with the hidden form input (bubbles `input` so
        FacetFiltersForm re-fetches).
     2. Drawer Apply/close in capture-phase, bypassing Dawn's MenuDrawer
        stacked listeners (bindEvents() re-binds after every AJAX update). */
  (function () {
    function fmtMoney(num) {
      return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    function buildStops(max, step) {
      var stops = [0];
      if (step > 0) {
        for (var v = step; v < max; v += step) stops.push(v);
      }
      if (stops[stops.length - 1] !== max) stops.push(max);
      return stops;
    }
    function snapToStop(val, stops) {
      var best = stops[0];
      var bestD = Math.abs(val - best);
      for (var i = 1; i < stops.length; i++) {
        var d = Math.abs(val - stops[i]);
        if (d < bestD) { bestD = d; best = stops[i]; }
      }
      return best;
    }
    function updateSliderUI(wrap, val) {
      var max = parseFloat(wrap.getAttribute('data-range-max')) || 0;
      var symbol = wrap.getAttribute('data-currency-symbol') || '';
      var pct = max > 0 ? Math.min(100, Math.max(0, (val / max) * 100)) : 0;
      wrap.style.setProperty('--wh-fill-pct', pct + '%');
      var label = wrap.querySelector('[data-wh-value]');
      if (label) label.textContent = symbol + fmtMoney(val);
    }
    function initSlider(wrap) {
      if (wrap.dataset.whInit === '1') return;
      wrap.dataset.whInit = '1';
      var handle = wrap.querySelector('[data-wh-handle]');
      var submit = wrap.querySelector('[data-wh-submit]');
      if (!handle || !submit) return;
      var rangeMax = parseFloat(wrap.getAttribute('data-range-max')) || 0;
      var stepSize = parseFloat(wrap.getAttribute('data-step-size')) || 0;
      var stops = buildStops(rangeMax, stepSize);
      updateSliderUI(wrap, parseFloat(handle.value));

      handle.addEventListener('input', function (e) {
        e.stopImmediatePropagation();
        var raw = parseFloat(handle.value);
        var snapped = snapToStop(raw, stops);
        if (snapped !== raw) handle.value = snapped;
        updateSliderUI(wrap, snapped);
      }, true);
      handle.addEventListener('change', function (e) {
        e.stopImmediatePropagation();
        var v = snapToStop(parseFloat(handle.value), stops);
        handle.value = v;
        submit.value = v >= rangeMax - 0.005 ? '' : fmtMoney(v);
        submit.dispatchEvent(new Event('input', { bubbles: true }));
        submit.dispatchEvent(new Event('change', { bubbles: true }));
      }, true);
    }
    function scanSliders() {
      document.querySelectorAll('[data-wh-price-range]').forEach(initSlider);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scanSliders);
    } else {
      scanSliders();
    }
    /* Dawn's facets.js replaces the filter markup on each change — re-scan. */
    var obsTargets = ['main-collection-filters', 'main-search-filters'];
    obsTargets.forEach(function (id) {
      var host = document.getElementById(id);
      if (host) new MutationObserver(scanSliders).observe(host, { childList: true, subtree: true });
    });

    /* Drawer Apply/Close handling — capture phase stops Dawn's stacked listeners. */
    function closeDrawer(wrapper) {
      if (!wrapper) return;
      var mainDetails = wrapper.querySelector('.wh-drawer__disclosure, .mobile-facets__disclosure');
      if (!mainDetails) return;
      wrapper.classList.remove('menu-opening');
      mainDetails.classList.remove('menu-opening');
      document.body.classList.remove('overflow-hidden-mobile');
      setTimeout(function () { mainDetails.removeAttribute('open'); }, 320);
    }
    document.addEventListener('click', function (event) {
      var apply = event.target.closest('[data-wh-drawer-apply]');
      if (apply) {
        event.stopImmediatePropagation();
        event.preventDefault();
        closeDrawer(apply.closest('.wh-drawer, .mobile-facets__wrapper'));
        return;
      }
      var closeX = event.target.closest('.wh-drawer__close, .mobile-facets__close, [data-wh-drawer-close]');
      if (closeX) {
        event.stopImmediatePropagation();
        event.preventDefault();
        closeDrawer(closeX.closest('.wh-drawer, .mobile-facets__wrapper'));
        return;
      }
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-mega-drawer"] && !Shopify.designMode) return;
  try {
    function titleCaseDrawerLabels() {
    document.querySelectorAll('.header-mega-drawer .header-mega-drawer__item-label').forEach(function (label) {
      var text = label.textContent;
      if (!text) return;
      var cased = text.toLowerCase().replace(/(^|\s|[-–—/])(\S)/g, function (_, sep, ch) {
        return sep + ch.toUpperCase();
      });
      if (cased !== text) label.textContent = cased;
    });
  }

  /* Returns open submenu details ordered root → deepest. Uses `.menu-opening`
     as the source of truth: Dawn keeps `[open]` set for ~400ms after a close
     begins, while `.menu-opening` is stripped synchronously, so filtering by
     the class avoids stale entries immediately after a close. */
  function getOpenSubmenuChain(drawer) {
    var scope = drawer.querySelector('.header-mega-drawer__nav');
    if (!scope) return [];
    var openDetails = Array.prototype.slice.call(scope.querySelectorAll('details[open].menu-opening'));
    openDetails.sort(function (a, b) {
      if (a === b) return 0;
      if (a.contains(b)) return -1;
      if (b.contains(a)) return 1;
      return 0;
    });
    return openDetails;
  }

  /* Delegate to Dawn's `closeSubmenu` so focus/aria/animation state stays
     in sync with the rest of MenuDrawer. Falls back to a minimal manual
     close if the custom element hasn't upgraded yet. */
  function closeDrawerSubmenu(drawer, details) {
    if (typeof drawer.closeSubmenu === 'function') {
      drawer.closeSubmenu(details);
      return;
    }
    details.classList.remove('menu-opening');
    var submenu = details.querySelector(':scope > .menu-drawer__submenu');
    if (submenu) submenu.classList.remove('submenu-open');
    window.setTimeout(function () {
      if (!details.classList.contains('menu-opening')) details.removeAttribute('open');
    }, 400);
  }

  function renderMegaDrawerBreadcrumbs(drawer) {
    var container = drawer.querySelector('[data-breadcrumbs]');
    if (!container) return;
    var chain = getOpenSubmenuChain(drawer);

    /* Move focus off any crumb that's about to be removed so focus
       doesn't fall to <body> — otherwise Dawn's focusout handling and
       our own mid-animation state can briefly drop the drawer's own
       visible state. */
    var active = document.activeElement;
    if (active && container.contains(active)) {
      var safe =
        drawer.querySelector('.header-mega-drawer__close') ||
        drawer.querySelector('summary.header-mega-drawer__trigger');
      if (safe) safe.focus({ preventScroll: true });
    }

    if (chain.length === 0) {
      container.textContent = '';
      container.setAttribute('hidden', '');
      return;
    }

    var rootLabel = container.getAttribute('data-root-label') || 'Menu';
    var crumbs = [{ label: rootLabel, depth: 0 }];
    chain.forEach(function (details, i) {
      var labelEl = details.querySelector(':scope > summary .header-mega-drawer__item-label');
      var text = labelEl ? labelEl.textContent.trim() : '';
      crumbs.push({ label: text, depth: i + 1 });
    });

    container.textContent = '';
    crumbs.forEach(function (crumb, i) {
      if (i > 0) {
        var sep = document.createElement('span');
        sep.className = 'header-mega-drawer__crumb-sep';
        sep.setAttribute('aria-hidden', 'true');
        sep.textContent = '›';
        container.appendChild(sep);
      }
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'header-mega-drawer__crumb';
      btn.setAttribute('data-depth', String(crumb.depth));
      if (i === crumbs.length - 1) {
        btn.setAttribute('aria-current', 'page');
        btn.disabled = true;
      }
      if (crumb.depth === 0) {
        btn.classList.add('header-mega-drawer__crumb--home');
        btn.setAttribute('aria-label', crumb.label);
        btn.innerHTML =
          '<span class="header-mega-drawer__crumb-home-icon" aria-hidden="true">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">' +
          '<path d="M3 10.5 12 3l9 7.5V20a1 1 0 0 1-1 1h-5v-6H9v6H4a1 1 0 0 1-1-1Z"/>' +
          '</svg>' +
          '</span>';
      } else {
        btn.textContent = crumb.label;
      }
      container.appendChild(btn);
    });

    container.removeAttribute('hidden');
  }

  function handleBreadcrumbClick(drawer, e) {
    var btn = e.target.closest('.header-mega-drawer__crumb');
    if (!btn || btn.hasAttribute('aria-current') || btn.disabled) return;
    e.preventDefault();
    e.stopPropagation();

    var targetDepth = parseInt(btn.getAttribute('data-depth'), 10);
    if (isNaN(targetDepth) || targetDepth < 0) return;

    /* Move focus to a stable element inside the drawer BEFORE removing
       the crumb from the DOM. Prevents focus from dropping to <body>. */
    var safe =
      drawer.querySelector('.header-mega-drawer__close') || drawer.querySelector('summary.header-mega-drawer__trigger');
    if (safe) safe.focus({ preventScroll: true });

    /* Close deepest → shallowest so Dawn's submenu-open cascade unwinds
       cleanly. Chain length > targetDepth means there are levels to close. */
    var chain = getOpenSubmenuChain(drawer);
    for (var i = chain.length - 1; i >= targetDepth; i--) {
      closeDrawerSubmenu(drawer, chain[i]);
    }

    /* Re-render immediately: chain is now stripped of `.menu-opening`,
       so render finds the updated state without waiting for the 400ms
       [open]-removal toggle. */
    renderMegaDrawerBreadcrumbs(drawer);
  }

  function initMegaDrawerColumns() {
    titleCaseDrawerLabels();
    document.querySelectorAll('.header-mega-drawer details').forEach(function (details) {
      details.addEventListener('toggle', function () {
        if (!details.open) return;
        var parentLi = details.parentElement;
        if (!parentLi || parentLi.tagName !== 'LI') return;
        var parentUl = parentLi.parentElement;
        if (!parentUl) return;

        var openSiblings = parentUl.querySelectorAll(':scope > li > details[open]');
        var replacingSibling = false;
        openSiblings.forEach(function (sibling) {
          if (sibling !== details) replacingSibling = true;
        });

        /* When switching between sibling submenus, the old sibling's
           `.menu-opening` is stripped below while Dawn's own setTimeout
           doesn't add `.menu-opening` to the new sibling until ~100ms
           later. In that gap, the depth-cascade `:has()` rule briefly
           stops matching and root items bounce back-and-forth. Adding
           `.menu-opening` now keeps the cascade state stable. */
        if (replacingSibling && !details.classList.contains('menu-opening')) {
          details.classList.add('menu-opening');
        }

        openSiblings.forEach(function (sibling) {
          if (sibling !== details) {
            sibling.classList.remove('menu-opening');
            sibling.removeAttribute('open');
          }
        });
      });
    });

    document.querySelectorAll('.header-mega-drawer').forEach(function (drawer) {
      var nav = drawer.querySelector('.header-mega-drawer__nav');
      if (nav) {
        /* `.menu-opening` is added by Dawn ~100ms after `[open]` flips,
           and removed synchronously on close. `[open]` lags by ~400ms
           on close. A `toggle` event only fires when `[open]` changes,
           so we rely on a class-level MutationObserver to catch the
           delayed open-state class toggle. */
        var mo = new MutationObserver(function () {
          renderMegaDrawerBreadcrumbs(drawer);
        });
        mo.observe(nav, {
          subtree: true,
          attributes: true,
          attributeFilter: ['class', 'open'],
        });
      }

      var crumbContainer = drawer.querySelector('[data-breadcrumbs]');
      if (crumbContainer) {
        crumbContainer.addEventListener('click', function (e) {
          handleBreadcrumbClick(drawer, e);
        });
      }

      /* Mobile home pills — one lives inside each submenu's back-row. A
         delegated listener on the drawer catches them all, including any
         added dynamically. Closes every open submenu so the user lands
         back on the root menu in one tap. `capture: true` ensures this
         runs before Dawn's own `.menu-drawer__close-button` handler (which
         would otherwise close the whole drawer if it won the bubble). */
      drawer.addEventListener(
        'click',
        function (e) {
          var homeBtn = e.target.closest('[data-mega-drawer-home]');
          if (!homeBtn || !drawer.contains(homeBtn)) return;
          e.preventDefault();
          e.stopPropagation();

          var safe =
            drawer.querySelector('.header-mega-drawer__close') ||
            drawer.querySelector('summary.header-mega-drawer__trigger');
          if (safe) safe.focus({ preventScroll: true });

          var chain = getOpenSubmenuChain(drawer);
          for (var i = chain.length - 1; i >= 0; i--) {
            closeDrawerSubmenu(drawer, chain[i]);
          }
        },
        true
      );

      var rootDetails = drawer.querySelector(':scope > details.menu-drawer-container');
      if (rootDetails) {
        rootDetails.addEventListener('toggle', function () {
          if (!rootDetails.open) {
            var container = drawer.querySelector('[data-breadcrumbs]');
            if (container) {
              container.setAttribute('hidden', '');
              container.textContent = '';
            }
          }
        });
      }
    });

    document.querySelectorAll('.header-mega-drawer').forEach(function (drawer) {
      var closeBtn = drawer.querySelector('.header-mega-drawer__close');
      if (!closeBtn) return;
      closeBtn.addEventListener('click', function (e) {
        var summary = drawer.querySelector('summary');
        drawer.closeMenuDrawer(e, summary);
      });

      var inner = drawer.querySelector('.header-mega-drawer__inner');
      var panel = drawer.querySelector('.header-mega-drawer__panel');
      if (inner && panel) {
        function checkScrollFade() {
          var noOverflow = inner.scrollHeight <= inner.clientHeight + 8;
          var atEnd = inner.scrollTop + inner.clientHeight >= inner.scrollHeight - 8;
          panel.classList.toggle('is-scrolled-end', noOverflow || atEnd);
        }
        inner.addEventListener('scroll', checkScrollFade, { passive: true });
        var details = drawer.querySelector('details');
        if (details) {
          details.addEventListener('toggle', function () {
            if (details.open) requestAnimationFrame(checkScrollFade);
          });
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaDrawerColumns);
  } else {
    initMegaDrawerColumns();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-mobile-drawer"] && !Shopify.designMode) return;
  try {
    class MobileDrawer extends HTMLElement {
    constructor() {
      super();
      this.scrollY = 0;
      this.history = [];
      this.onKeydown = this.onKeydown.bind(this);
    }

    /* Children are not bound directly here. All clicks are handled via
       document-level delegation (see bottom of this script) so the open
       button works regardless of when this element upgrades, whether
       its children are rebuilt by another script, or whether the host
       gets disconnected/reconnected. The host element's only job is to
       expose imperative methods (open, close, back, openLevel) that the
       delegated handler calls into. */
    ensureRefs() {
      if (this._refs) return;
      this.openBtn = this.querySelector('[data-mobile-drawer-open]');
      this.closeBtn = this.querySelector('[data-mobile-drawer-close]');
      this.backBtn = this.querySelector('[data-mobile-drawer-back]');
      this.breadcrumb = this.querySelector('[data-mobile-drawer-breadcrumb]');
      this.titleEl = this.querySelector('[data-mobile-drawer-title]');
      this.panel = this.querySelector('[data-mobile-drawer-panel]');
      this.levels = new Map();
      this.querySelectorAll('[data-mobile-drawer-level]').forEach((el) => {
        this.levels.set(el.getAttribute('data-mobile-drawer-level'), el);
      });

      /* CSS `text-transform: capitalize` only uppercases the first
         letter of each word; an all-caps source like "PRE-ORDERS"
         stays "PRE-ORDERS". Manually downcase + re-capitalize each
         label so Title Case reads correctly regardless of how the
         merchant typed it in the menu config.

         IMPORTANT: only target LABEL elements (text nodes), never the
         level <section>s themselves — setting textContent on a section
         would replace its entire DOM subtree with concatenated text. */
      const titleCase = (text) =>
        text.toLowerCase().replace(/(^|\s|[-–—/])(\S)/g, (_, sep, ch) => sep + ch.toUpperCase());

      this.querySelectorAll('.mobile-drawer__item-label, [data-mobile-drawer-title]').forEach((label) => {
        const text = (label.textContent || '').trim();
        if (!text) return;
        const cased = titleCase(text);
        if (cased !== label.textContent) label.textContent = cased;
      });

      // Also re-cast the level-title data attribute on each
      // `[data-mobile-drawer-open-level]` button so when JS pulls it to
      // populate the breadcrumb at openLevel() time it's already cased.
      this.querySelectorAll('[data-mobile-drawer-open-level]').forEach((btn) => {
        const t = btn.getAttribute('data-mobile-drawer-level-title');
        if (!t) return;
        const cased = titleCase(t);
        if (cased !== t) btn.setAttribute('data-mobile-drawer-level-title', cased);
      });

      this.rootTitle = this.titleEl ? this.titleEl.textContent.trim() : '';
      this._refs = true;
    }

    /* History depth determines the back-button glyph:
         depth 1 → one level from root, back goes home (home icon)
         depth ≥ 2 → deeper, back goes to parent (back arrow) */
    syncBackMode() {
      if (!this.backBtn) return;
      this.backBtn.setAttribute('data-back-mode', this.history.length > 1 ? 'back' : 'home');
    }

    open() {
      this.ensureRefs();
      if (!this.panel) return;

      /* Portal: move the panel to <body> so it escapes any ancestor
         stacking context (the homepage `.header-wrapper--overlay`
         creates one at z:10 with `isolation: isolate`, which would
         otherwise cap our panel's z-index below the announcement bar
         at z:12). Stash the original parent + sibling so close() can
         put it back exactly where it was. */
      if (this.panel.parentElement !== document.body) {
        this._panelOrigParent = this.panel.parentElement;
        this._panelOrigNext = this.panel.nextSibling;
        document.body.appendChild(this.panel);
      }

      this.scrollY = window.scrollY || window.pageYOffset || 0;
      const body = document.body;
      body.style.position = 'fixed';
      body.style.top = `-${this.scrollY}px`;
      body.style.left = '0';
      body.style.right = '0';
      body.style.width = '100%';

      this.panel.hidden = false;
      void this.panel.offsetHeight; // reflow so transition runs
      this.panel.setAttribute('data-open', '');
      this.panel.setAttribute('aria-hidden', 'false');
      if (this.openBtn) this.openBtn.setAttribute('aria-expanded', 'true');

      document.addEventListener('keydown', this.onKeydown);
    }

    close() {
      this.ensureRefs();
      if (!this.panel) return;
      this.panel.removeAttribute('data-open');
      this.panel.setAttribute('aria-hidden', 'true');
      if (this.openBtn) this.openBtn.setAttribute('aria-expanded', 'false');
      document.removeEventListener('keydown', this.onKeydown);

      const body = document.body;
      body.style.position = '';
      body.style.top = '';
      body.style.left = '';
      body.style.right = '';
      body.style.width = '';
      window.scrollTo(0, this.scrollY);

      /* Wait for the clip-path collapse to finish, then mark hidden and
         move the panel back to its original parent. Listening for any
         transitionend on the panel itself; reduced-motion users get the
         opacity property name instead of clip-path, so accept either. */
      const onEnd = (event) => {
        if (event.target !== this.panel) return;
        const p = event.propertyName;
        if (p !== 'clip-path' && p !== '-webkit-clip-path' && p !== 'opacity') return;
        if (this.panel.hasAttribute('data-open')) return;

        this.panel.hidden = true;
        this.panel.removeEventListener('transitionend', onEnd);

        // Restore original DOM position so re-opens portal cleanly again.
        if (this._panelOrigParent && this.panel.parentElement === document.body) {
          if (this._panelOrigNext && this._panelOrigNext.parentNode === this._panelOrigParent) {
            this._panelOrigParent.insertBefore(this.panel, this._panelOrigNext);
          } else {
            this._panelOrigParent.appendChild(this.panel);
          }
        }
      };
      this.panel.addEventListener('transitionend', onEnd);

      this.openBtn.focus({ preventScroll: true });
    }

    onKeydown(event) {
      if (event.key !== 'Escape') return;
      if (this.history.length > 0) this.back();
      else this.close();
    }

    getActiveLevel() {
      // Query from the panel rather than the host. After open() portals
      // the panel into <body>, level <section>s are no longer descendants
      // of <mobile-drawer>, so a host-scoped query returns null.
      return (this.panel || this).querySelector('[data-mobile-drawer-level-active]');
    }

    openLevel(id, title) {
      this.ensureRefs();
      const next = this.levels?.get(id);
      if (!next) return;
      const current = this.getActiveLevel();
      if (!current || current === next) return;

      // Push the level we're leaving so back() can restore its title +
      // scroll position. `title` here is what's currently in the header.
      this.history.push({
        id: current.getAttribute('data-mobile-drawer-level'),
        title: this.titleEl.textContent.trim(),
        scrollTop: current.scrollTop,
      });

      current.setAttribute('data-mobile-drawer-level-behind', '');
      current.removeAttribute('data-mobile-drawer-level-active');

      next.scrollTop = 0;
      next.setAttribute('data-mobile-drawer-level-active', '');
      next.removeAttribute('data-mobile-drawer-level-behind');

      // Header chrome — current title becomes the new level, breadcrumb
      // is shown, back button glyph swaps based on history depth.
      this.titleEl.textContent = title || next.getAttribute('data-mobile-drawer-level-title') || '';
      if (this.breadcrumb) this.breadcrumb.hidden = false;
      this.syncBackMode();
    }

    back() {
      this.ensureRefs();
      const previous = this.history.pop();
      if (!previous) return;
      const current = this.getActiveLevel();
      const prevEl = this.levels?.get(previous.id);
      if (!current || !prevEl) return;

      current.removeAttribute('data-mobile-drawer-level-active');
      prevEl.removeAttribute('data-mobile-drawer-level-behind');
      prevEl.setAttribute('data-mobile-drawer-level-active', '');

      requestAnimationFrame(() => {
        prevEl.scrollTop = previous.scrollTop || 0;
      });

      this.titleEl.textContent = previous.title || this.rootTitle;
      if (this.history.length === 0) {
        if (this.breadcrumb) this.breadcrumb.hidden = true;
      }
      this.syncBackMode();
    }
  }

  if (!customElements.get('mobile-drawer')) {
    customElements.define('mobile-drawer', MobileDrawer);
  }

  /* Document-level click delegation. The custom-element approach above
     can fail to bind if the element upgrades before its descendants are
     parsed, or if another script swaps the trigger DOM after mount.
     Delegating here means the trigger always works.

     `findHost` resolves the <mobile-drawer> for a click target. When
     the panel is portaled to <body> while open, the panel's children
     are no longer descendants of the <mobile-drawer> host, so
     `closest('mobile-drawer')` returns null. Fall back to a singleton
     lookup since the page only has one mobile drawer. */
  function findHost(target) {
    return target.closest('mobile-drawer') || document.querySelector('mobile-drawer');
  }

  document.addEventListener('click', function (event) {
    const openTarget = event.target.closest('[data-mobile-drawer-open]');
    if (openTarget) {
      const host = findHost(openTarget);
      if (host) {
        event.preventDefault();
        if (typeof host.open === 'function') host.open();
        return;
      }
    }

    const closeTarget = event.target.closest('[data-mobile-drawer-close]');
    if (closeTarget) {
      const host = findHost(closeTarget);
      if (host && typeof host.close === 'function') {
        event.preventDefault();
        host.close();
        return;
      }
    }

    const backTarget = event.target.closest('[data-mobile-drawer-back]');
    if (backTarget) {
      const host = findHost(backTarget);
      if (host && typeof host.back === 'function') {
        event.preventDefault();
        host.back();
        return;
      }
    }

    const levelTarget = event.target.closest('[data-mobile-drawer-open-level]');
    if (levelTarget) {
      const host = findHost(levelTarget);
      if (host && typeof host.openLevel === 'function') {
        event.preventDefault();
        const id = levelTarget.getAttribute('data-mobile-drawer-open-level');
        const title = levelTarget.getAttribute('data-mobile-drawer-level-title') || '';
        host.openLevel(id, title);
      }
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-search"] && !Shopify.designMode) return;
  try {
    class ImmersiveSearch extends HTMLElement {
    constructor() {
      super();
      this.openBtn = this.querySelector('[data-immersive-search-open]');
      this.closeBtn = this.querySelector('[data-immersive-search-close]');
      this.overlay = this.querySelector('[data-immersive-search-overlay]');
      this.input = this.querySelector('input[type="search"]');
      this.scrollY = 0;
      this.onKeydown = this.onKeydown.bind(this);
    }

    connectedCallback() {
      this.openBtn?.addEventListener('click', this.open.bind(this));
      this.closeBtn?.addEventListener('click', this.close.bind(this));
      this.input?.addEventListener('input', this.syncState.bind(this));

      const form = this.querySelector('form');
      form?.addEventListener('reset', () => {
        requestAnimationFrame(() => this.syncState());
      });

      this.overlay?.addEventListener('click', (event) => {
        if (event.target === this.overlay) this.close();
      });
    }

    onKeydown(event) {
      if (event.key === 'Escape') this.close();
    }

    open() {
      this.scrollY = window.scrollY || window.pageYOffset || 0;
      const body = document.body;
      body.style.position = 'fixed';
      body.style.top = `-${this.scrollY}px`;
      body.style.left = '0';
      body.style.right = '0';
      body.style.width = '100%';

      this.overlay.hidden = false;
      void this.overlay.offsetHeight; // force reflow so the transition runs
      this.overlay.setAttribute('data-open', '');
      this.overlay.setAttribute('aria-hidden', 'false');
      this.openBtn.setAttribute('aria-expanded', 'true');

      document.addEventListener('keydown', this.onKeydown);

      // Defer focus so the transition has begun and screen readers announce the dialog.
      setTimeout(() => this.input?.focus({ preventScroll: true }), 50);
      this.syncState();
    }

    close() {
      this.overlay.removeAttribute('data-open');
      this.overlay.setAttribute('aria-hidden', 'true');
      this.openBtn.setAttribute('aria-expanded', 'false');
      document.removeEventListener('keydown', this.onKeydown);

      const body = document.body;
      body.style.position = '';
      body.style.top = '';
      body.style.left = '';
      body.style.right = '';
      body.style.width = '';
      window.scrollTo(0, this.scrollY);

      const onEnd = (event) => {
        if (event.target !== this.overlay || event.propertyName !== 'opacity') return;
        if (!this.overlay.hasAttribute('data-open')) this.overlay.hidden = true;
        this.overlay.removeEventListener('transitionend', onEnd);
      };
      this.overlay.addEventListener('transitionend', onEnd);

      this.openBtn.focus({ preventScroll: true });
    }

    syncState() {
      const hasValue = !!(this.input && this.input.value.trim().length);
      if (hasValue) {
        this.setAttribute('data-state', 'active');
      } else {
        this.removeAttribute('data-state');
      }
    }
  }

  if (!customElements.get('immersive-search')) {
    customElements.define('immersive-search', ImmersiveSearch);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["logo-marquee-render"] && !Shopify.designMode) return;
  try {
    class LogoMarquee extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.logo-marquee__track');
      if (!this.track) return;
      const seed = this.track.querySelector('.logo-marquee__group');
      if (!seed) return;
      this.seedHTML = seed.outerHTML;

      this.fill = this.fill.bind(this);
      this.fill();

      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(() => this.fill());
        this.ro.observe(this);
      } else {
        window.addEventListener('resize', this.fill);
      }
    }

    fill() {
      this.track.innerHTML = this.seedHTML;
      const containerWidth = this.getBoundingClientRect().width;
      if (!containerWidth) return;

      const groupWidth = this.track.firstElementChild.getBoundingClientRect().width;
      if (!groupWidth) return;

      const needed = Math.max(2, Math.ceil((containerWidth * 2) / groupWidth));
      const total = needed % 2 === 0 ? needed : needed + 1;
      for (let i = 1; i < total; i++) {
        this.track.insertAdjacentHTML('beforeend', this.seedHTML);
      }

      this.track.style.animation = 'none';
      void this.track.offsetWidth;
      this.track.style.animation = '';
    }

    disconnectedCallback() {
      if (this.ro) this.ro.disconnect();
      window.removeEventListener('resize', this.fill);
    }
  }

  if (!customElements.get('logo-marquee')) {
    customElements.define('logo-marquee', LogoMarquee);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    function initGallery(gallery) {
      if (gallery.dataset.whArrowsBound === '1') return;
      const prevArrow = gallery.querySelector('.wh-gallery-arrow--prev');
      const nextArrow = gallery.querySelector('.wh-gallery-arrow--next');
      const prevBtn = gallery.querySelector('.slider-buttons button[name="previous"]');
      const nextBtn = gallery.querySelector('.slider-buttons button[name="next"]');
      const slider = gallery.querySelector('[id^="Slider-"]');
      if (!prevArrow || !nextArrow || !prevBtn || !nextBtn || !slider) return;
      gallery.dataset.whArrowsBound = '1';

      const slides = () => gallery.querySelectorAll('[id^="Slide-"]');

      const syncDisabled = () => {
        const items = Array.from(slides()).filter((el) => el.clientWidth > 0);
        if (!items.length) return;
        const scrollLeft = slider.scrollLeft;
        const viewportRight = slider.clientWidth + scrollLeft;
        const first = items[0];
        const last = items[items.length - 1];
        const atStart = scrollLeft <= first.offsetLeft + 1;
        const atEnd = last.offsetLeft + last.clientWidth <= viewportRight + 1;
        if (atStart || prevBtn.hasAttribute('disabled')) prevArrow.setAttribute('disabled', '');
        else prevArrow.removeAttribute('disabled');
        if (atEnd || nextBtn.hasAttribute('disabled')) nextArrow.setAttribute('disabled', '');
        else nextArrow.removeAttribute('disabled');
      };

      prevArrow.addEventListener('click', (e) => {
        e.preventDefault();
        prevBtn.click();
      });
      nextArrow.addEventListener('click', (e) => {
        e.preventDefault();
        nextBtn.click();
      });

      new MutationObserver(syncDisabled).observe(prevBtn, { attributes: true, attributeFilter: ['disabled'] });
      new MutationObserver(syncDisabled).observe(nextBtn, { attributes: true, attributeFilter: ['disabled'] });
      slider.addEventListener('scroll', syncDisabled, { passive: true });
      window.addEventListener('resize', syncDisabled);
      syncDisabled();
      requestAnimationFrame(syncDisabled);
      setTimeout(syncDisabled, 300);
    }

    function initDots(gallery) {
      if (gallery.dataset.whDotsBound === '1') return;
      const dots = gallery.querySelectorAll('.wh-slider-dot');
      const slider = gallery.querySelector('[id^="Slider-"]');
      if (!dots.length || !slider) return;
      gallery.dataset.whDotsBound = '1';

      const slidesOf = () => gallery.querySelectorAll('[id^="Slide-"]');

      const setActive = (idx) => {
        dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
      };

      // Click a dot → smooth-scroll the slider to that slide.
      dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          const items = slidesOf();
          const target = items[i];
          if (!target) return;
          slider.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
        });
      });

      // Active state follows whichever slide is closest to the scroll
      // origin — covers swipe, drag, and arrow-button navigation alike.
      const sync = () => {
        const items = Array.from(slidesOf()).filter((el) => el.clientWidth > 0);
        if (!items.length) return;
        const scrollLeft = slider.scrollLeft;
        let nearest = 0;
        let best = Infinity;
        items.forEach((item, i) => {
          const dist = Math.abs(item.offsetLeft - scrollLeft);
          if (dist < best) {
            best = dist;
            nearest = i;
          }
        });
        setActive(nearest);
      };

      slider.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    }

    function bootstrap() {
      document.querySelectorAll('slider-component[id^="GalleryViewer-"]').forEach((g) => {
        initGallery(g);
        initDots(g);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootstrap);
    } else {
      bootstrap();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-upsell"] && !Shopify.designMode) return;
  try {
    class ProductUpsell extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.pu-upsell__track');
      this.prev = this.querySelector('.pu-upsell__nav--prev');
      this.next = this.querySelector('.pu-upsell__nav--next');
      this._setupMobileReorder();
      if (!this.track || !this.prev || !this.next) return;

      this.prev.addEventListener('click', () => this._scroll(-1));
      this.next.addEventListener('click', () => this._scroll(1));
      this.track.addEventListener('scroll', () => this._updateNav(), { passive: true });

      this._updateNav();
      this._resizeObserver = new ResizeObserver(() => this._updateNav());
      this._resizeObserver.observe(this.track);
    }

    _setupMobileReorder() {
      const container = this.closest('.product__info-container');
      if (!container) return;
      const description = container.querySelector('.product__description');
      if (!description) return;
      this._desktopAnchor = this.nextElementSibling;
      this._desktopParent = this.parentElement;
      this._descriptionRef = description;
      this._mq = window.matchMedia('(max-width: 749px)');
      this._applyReorder = () => {
        if (this._mq.matches) {
          if (this._descriptionRef.previousElementSibling !== this) {
            this._descriptionRef.parentElement.insertBefore(this, this._descriptionRef);
          }
        } else {
          if (this.parentElement !== this._desktopParent || this.nextElementSibling !== this._desktopAnchor) {
            if (this._desktopAnchor && this._desktopAnchor.parentElement === this._desktopParent) {
              this._desktopParent.insertBefore(this, this._desktopAnchor);
            } else {
              this._desktopParent.appendChild(this);
            }
          }
        }
      };
      this._applyReorder();
      this._mq.addEventListener('change', this._applyReorder);
    }

    disconnectedCallback() {
      if (this._resizeObserver) this._resizeObserver.disconnect();
      if (this._mq && this._applyReorder) this._mq.removeEventListener('change', this._applyReorder);
    }

    _scroll(direction) {
      const firstItem = this.track.querySelector('.pu-upsell__item');
      const gap = parseFloat(getComputedStyle(this.track).columnGap || '8') || 8;
      const step = firstItem ? firstItem.offsetWidth + gap : this.track.clientWidth * 0.8;
      this.track.scrollBy({ left: step * direction, behavior: 'smooth' });
    }

    _updateNav() {
      const max = this.track.scrollWidth - this.track.clientWidth - 1;
      const x = this.track.scrollLeft;
      this.prev.hidden = x <= 0;
      this.next.hidden = x >= max;
    }
  }

  if (!customElements.get('product-upsell')) {
    customElements.define('product-upsell', ProductUpsell);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-add-inline"] && !Shopify.designMode) return;
  try {
    class InlineQuickAdd extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('.inline-quick-add__select');
      this.selectWrap = this.querySelector('.inline-quick-add__select-wrap');
      this.formWrap = this.querySelector('.inline-quick-add__form');

      if (!this.select) return;

      this.select.addEventListener('change', this._onSelect.bind(this));
    }

    _onSelect() {
      var variantId = this.select.value;
      if (!variantId) return;

      var selectedOption = this.select.options[this.select.selectedIndex];
      var variantText = selectedOption.textContent.split(' — ')[0].trim();

      this.selectWrap.hidden = true;

      this.formWrap.hidden = false;
      var input = this.formWrap.querySelector('.product-variant-id');
      input.value = variantId;
      input.disabled = false;

      var submitText = this.formWrap.querySelector('.inline-quick-add__submit-text');
      if (submitText) {
        submitText.textContent = variantText;
      }
    }
  }

  if (!customElements.get('inline-quick-add')) {
    customElements.define('inline-quick-add', InlineQuickAdd);
  }
  } catch(e) { console.error(e); }
})();

})();
